import firebase from 'firebase/app'
import Auth from 'firebase/auth'
import Database from 'firebase/database'
import Raven from 'raven-js'

import config from '../config/firebase'

const firebaseApp = {
  socket: null,
  ref: null,
  TIMESTAMP: null,
  init(org) {
    this.socket = firebase.initializeApp(config)
    this.TIMESTAMP = firebase.database.ServerValue.TIMESTAMP
    this.ref = this.socket.database().ref(org)
    this.roundRobin = this.socket.database().ref('round_robin')
    this.notifyInstall = this.socket.database().ref('notify_install')
    this.Integrations = this.socket.database().ref('integration_messages')
  },
  signInUser(token) {
    return new Promise(function( resolve, reject ){
      firebase.auth()
        .onAuthStateChanged(function(user) {
          if (user) {
            Raven.captureBreadcrumb({
              message: 'Resolving: User was found, Firebase is already authenticated',
              category: 'requests'
            })
            resolve(user)
          }
          else if (!token) {
            Raven.captureBreadcrumb({
              message: 'Rejecting: User and token was not found',
              category: 'requests'
            })
            reject({code:'no-token'})
          }
          else {
            Raven.captureBreadcrumb({
              message: 'Trying to Sign In with Custom Token',
              category: 'requests'
            })
            firebase.auth()
              .signInWithCustomToken(token)
              .then((user)=> {
                resolve(user)
              })
              .catch((error)=> reject(error))
          }
      })
    })

  }
}

export default firebaseApp
